import type { DisablerState } from './reducer';
import { compose } from 'redux';

import type { AppState } from '../AppState';

const selectDisabler = (state: AppState) => state.disabler;

export const selectDisablerDevicesStatus = compose(
  (state: DisablerState) => state.disablerDevicesStatusWebData,
  selectDisabler
);

export const selectDisablerDevices = compose(
  (state: DisablerState) => state.disablerDevicesWebData,
  selectDisabler
);
